/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LayoutRouteImport } from './routes/_layout'
import { Route as LayoutIndexRouteImport } from './routes/_layout/index'
import { Route as LayoutTermsRouteImport } from './routes/_layout/terms'
import { Route as LayoutStoryModeRouteImport } from './routes/_layout/story-mode'
import { Route as LayoutSignUpRouteImport } from './routes/_layout/sign-up'
import { Route as LayoutSignInRouteImport } from './routes/_layout/sign-in'
import { Route as LayoutSettingsRouteImport } from './routes/_layout/settings'
import { Route as LayoutPrivacyRouteImport } from './routes/_layout/privacy'
import { Route as LayoutMyStoriesRouteImport } from './routes/_layout/my-stories'
import { Route as LayoutHelpRouteImport } from './routes/_layout/help'
import { Route as Layout404RouteImport } from './routes/_layout/404'
import { Route as StoryStoryIdPrintRouteImport } from './routes/story.$storyId.print'
import { Route as LayoutUpgradeProcessingRouteImport } from './routes/_layout/upgrade.processing'
import { Route as LayoutStoryStoryIdRouteImport } from './routes/_layout/story.$storyId'
import { Route as LayoutStoryShareTokenRouteImport } from './routes/_layout/story.share.$token'

const LayoutRoute = LayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutIndexRoute = LayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutTermsRoute = LayoutTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutStoryModeRoute = LayoutStoryModeRouteImport.update({
  id: '/story-mode',
  path: '/story-mode',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutSignUpRoute = LayoutSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutSignInRoute = LayoutSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutSettingsRoute = LayoutSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutPrivacyRoute = LayoutPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutMyStoriesRoute = LayoutMyStoriesRouteImport.update({
  id: '/my-stories',
  path: '/my-stories',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutHelpRoute = LayoutHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => LayoutRoute,
} as any)
const Layout404Route = Layout404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => LayoutRoute,
} as any)
const StoryStoryIdPrintRoute = StoryStoryIdPrintRouteImport.update({
  id: '/story/$storyId/print',
  path: '/story/$storyId/print',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutUpgradeProcessingRoute = LayoutUpgradeProcessingRouteImport.update({
  id: '/upgrade/processing',
  path: '/upgrade/processing',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutStoryStoryIdRoute = LayoutStoryStoryIdRouteImport.update({
  id: '/story/$storyId',
  path: '/story/$storyId',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutStoryShareTokenRoute = LayoutStoryShareTokenRouteImport.update({
  id: '/story/share/$token',
  path: '/story/share/$token',
  getParentRoute: () => LayoutRoute,
} as any)

export interface FileRoutesByFullPath {
  '/404': typeof Layout404Route
  '/help': typeof LayoutHelpRoute
  '/my-stories': typeof LayoutMyStoriesRoute
  '/privacy': typeof LayoutPrivacyRoute
  '/settings': typeof LayoutSettingsRoute
  '/sign-in': typeof LayoutSignInRoute
  '/sign-up': typeof LayoutSignUpRoute
  '/story-mode': typeof LayoutStoryModeRoute
  '/terms': typeof LayoutTermsRoute
  '/': typeof LayoutIndexRoute
  '/story/$storyId': typeof LayoutStoryStoryIdRoute
  '/upgrade/processing': typeof LayoutUpgradeProcessingRoute
  '/story/$storyId/print': typeof StoryStoryIdPrintRoute
  '/story/share/$token': typeof LayoutStoryShareTokenRoute
}
export interface FileRoutesByTo {
  '/404': typeof Layout404Route
  '/help': typeof LayoutHelpRoute
  '/my-stories': typeof LayoutMyStoriesRoute
  '/privacy': typeof LayoutPrivacyRoute
  '/settings': typeof LayoutSettingsRoute
  '/sign-in': typeof LayoutSignInRoute
  '/sign-up': typeof LayoutSignUpRoute
  '/story-mode': typeof LayoutStoryModeRoute
  '/terms': typeof LayoutTermsRoute
  '/': typeof LayoutIndexRoute
  '/story/$storyId': typeof LayoutStoryStoryIdRoute
  '/upgrade/processing': typeof LayoutUpgradeProcessingRoute
  '/story/$storyId/print': typeof StoryStoryIdPrintRoute
  '/story/share/$token': typeof LayoutStoryShareTokenRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_layout': typeof LayoutRouteWithChildren
  '/_layout/404': typeof Layout404Route
  '/_layout/help': typeof LayoutHelpRoute
  '/_layout/my-stories': typeof LayoutMyStoriesRoute
  '/_layout/privacy': typeof LayoutPrivacyRoute
  '/_layout/settings': typeof LayoutSettingsRoute
  '/_layout/sign-in': typeof LayoutSignInRoute
  '/_layout/sign-up': typeof LayoutSignUpRoute
  '/_layout/story-mode': typeof LayoutStoryModeRoute
  '/_layout/terms': typeof LayoutTermsRoute
  '/_layout/': typeof LayoutIndexRoute
  '/_layout/story/$storyId': typeof LayoutStoryStoryIdRoute
  '/_layout/upgrade/processing': typeof LayoutUpgradeProcessingRoute
  '/story/$storyId/print': typeof StoryStoryIdPrintRoute
  '/_layout/story/share/$token': typeof LayoutStoryShareTokenRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/404'
    | '/help'
    | '/my-stories'
    | '/privacy'
    | '/settings'
    | '/sign-in'
    | '/sign-up'
    | '/story-mode'
    | '/terms'
    | '/'
    | '/story/$storyId'
    | '/upgrade/processing'
    | '/story/$storyId/print'
    | '/story/share/$token'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/404'
    | '/help'
    | '/my-stories'
    | '/privacy'
    | '/settings'
    | '/sign-in'
    | '/sign-up'
    | '/story-mode'
    | '/terms'
    | '/'
    | '/story/$storyId'
    | '/upgrade/processing'
    | '/story/$storyId/print'
    | '/story/share/$token'
  id:
    | '__root__'
    | '/_layout'
    | '/_layout/404'
    | '/_layout/help'
    | '/_layout/my-stories'
    | '/_layout/privacy'
    | '/_layout/settings'
    | '/_layout/sign-in'
    | '/_layout/sign-up'
    | '/_layout/story-mode'
    | '/_layout/terms'
    | '/_layout/'
    | '/_layout/story/$storyId'
    | '/_layout/upgrade/processing'
    | '/story/$storyId/print'
    | '/_layout/story/share/$token'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  LayoutRoute: typeof LayoutRouteWithChildren
  StoryStoryIdPrintRoute: typeof StoryStoryIdPrintRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout/': {
      id: '/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LayoutIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/terms': {
      id: '/_layout/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof LayoutTermsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/story-mode': {
      id: '/_layout/story-mode'
      path: '/story-mode'
      fullPath: '/story-mode'
      preLoaderRoute: typeof LayoutStoryModeRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/sign-up': {
      id: '/_layout/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof LayoutSignUpRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/sign-in': {
      id: '/_layout/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof LayoutSignInRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/settings': {
      id: '/_layout/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof LayoutSettingsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/privacy': {
      id: '/_layout/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof LayoutPrivacyRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/my-stories': {
      id: '/_layout/my-stories'
      path: '/my-stories'
      fullPath: '/my-stories'
      preLoaderRoute: typeof LayoutMyStoriesRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/help': {
      id: '/_layout/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof LayoutHelpRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/404': {
      id: '/_layout/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof Layout404RouteImport
      parentRoute: typeof LayoutRoute
    }
    '/story/$storyId/print': {
      id: '/story/$storyId/print'
      path: '/story/$storyId/print'
      fullPath: '/story/$storyId/print'
      preLoaderRoute: typeof StoryStoryIdPrintRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout/upgrade/processing': {
      id: '/_layout/upgrade/processing'
      path: '/upgrade/processing'
      fullPath: '/upgrade/processing'
      preLoaderRoute: typeof LayoutUpgradeProcessingRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/story/$storyId': {
      id: '/_layout/story/$storyId'
      path: '/story/$storyId'
      fullPath: '/story/$storyId'
      preLoaderRoute: typeof LayoutStoryStoryIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/story/share/$token': {
      id: '/_layout/story/share/$token'
      path: '/story/share/$token'
      fullPath: '/story/share/$token'
      preLoaderRoute: typeof LayoutStoryShareTokenRouteImport
      parentRoute: typeof LayoutRoute
    }
  }
}

interface LayoutRouteChildren {
  Layout404Route: typeof Layout404Route
  LayoutHelpRoute: typeof LayoutHelpRoute
  LayoutMyStoriesRoute: typeof LayoutMyStoriesRoute
  LayoutPrivacyRoute: typeof LayoutPrivacyRoute
  LayoutSettingsRoute: typeof LayoutSettingsRoute
  LayoutSignInRoute: typeof LayoutSignInRoute
  LayoutSignUpRoute: typeof LayoutSignUpRoute
  LayoutStoryModeRoute: typeof LayoutStoryModeRoute
  LayoutTermsRoute: typeof LayoutTermsRoute
  LayoutIndexRoute: typeof LayoutIndexRoute
  LayoutStoryStoryIdRoute: typeof LayoutStoryStoryIdRoute
  LayoutUpgradeProcessingRoute: typeof LayoutUpgradeProcessingRoute
  LayoutStoryShareTokenRoute: typeof LayoutStoryShareTokenRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  Layout404Route: Layout404Route,
  LayoutHelpRoute: LayoutHelpRoute,
  LayoutMyStoriesRoute: LayoutMyStoriesRoute,
  LayoutPrivacyRoute: LayoutPrivacyRoute,
  LayoutSettingsRoute: LayoutSettingsRoute,
  LayoutSignInRoute: LayoutSignInRoute,
  LayoutSignUpRoute: LayoutSignUpRoute,
  LayoutStoryModeRoute: LayoutStoryModeRoute,
  LayoutTermsRoute: LayoutTermsRoute,
  LayoutIndexRoute: LayoutIndexRoute,
  LayoutStoryStoryIdRoute: LayoutStoryStoryIdRoute,
  LayoutUpgradeProcessingRoute: LayoutUpgradeProcessingRoute,
  LayoutStoryShareTokenRoute: LayoutStoryShareTokenRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  LayoutRoute: LayoutRouteWithChildren,
  StoryStoryIdPrintRoute: StoryStoryIdPrintRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
